/**
 * ============================================================================
 * USER DASHBOARD LAYOUT COMPONENT - 100% Ready
 * ============================================================================
 * 
 * Enhanced shared layout for all user pages with Header, Sidebar, and Footer
 */

import React, { useState } from 'react';
import UserHeader from './UserHeader';
import UserSidebar from './UserSidebar';
import UserFooter from './UserFooter';

/**
 * User Dashboard Layout Component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Page content
 * @param {boolean} props.hideSidebar - Hide sidebar (optional)
 * @param {boolean} props.hideFooter - Hide footer (optional)
 * @returns {JSX.Element}
 */
const UserDashboardLayout = ({ children, hideSidebar = false, hideFooter = false }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col">
      {/* Header */}
      <UserHeader
        onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
        sidebarOpen={sidebarOpen}
      />

      {/* Layout Container */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        {!hideSidebar && (
          <UserSidebar
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />
        )}

        {/* Main Content */}
        <main className={`flex-1 overflow-y-auto ${!hideSidebar ? 'lg:ml-0' : ''}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5">
            {children}
          </div>
        </main>
      </div>

      {/* Footer */}
      {!hideFooter && <UserFooter />}
    </div>
  );
};

export default UserDashboardLayout;
